/** Shared payment labels + badge colors (aligned with POS sales list). */

export type PaymentMethodKey =
  | "cash"
  | "card"
  | "online"
  | "upi"
  | "other";

const BADGE_COLORS: Record<
  PaymentMethodKey,
  { bgcolor: string; color: string }
> = {
  cash: { bgcolor: "#e8f5e9", color: "#1b7a3d" },
  card: { bgcolor: "#e3f2fd", color: "#1a5fb4" },
  online: { bgcolor: "#f3e5f5", color: "#6c3fc5" },
  upi: { bgcolor: "#e0f7f5", color: "#0d7377" },
  other: { bgcolor: "#fff3e0", color: "#a15c00" },
};

const LABELS: Record<PaymentMethodKey, string> = {
  cash: "Cash",
  card: "NFC Card",
  online: "Online",
  upi: "UPI",
  other: "Other",
};

export function normalizePaymentMethodKey(
  raw?: string | null
): PaymentMethodKey {
  const m = String(raw || "cash")
    .trim()
    .toLowerCase();
  if (m === "card" || m === "nfc_card") return "card";
  if (m === "online") return "online";
  if (m === "upi" || m === "netbanking") return "upi";
  if (m === "other") return "other";
  if (m === "cash") return "cash";
  return "other";
}

export function paymentMethodLabel(raw?: string | null): string {
  const key = normalizePaymentMethodKey(raw);
  if (key === "other") {
    const rawLabel = String(raw || "").trim();
    if (rawLabel && !["cash", "card", "online", "upi", "other", "nfc_card", "netbanking"].includes(rawLabel.toLowerCase())) {
      return rawLabel;
    }
  }
  return LABELS[key];
}

export function paymentMethodChipSx(raw?: string | null) {
  const colors = BADGE_COLORS[normalizePaymentMethodKey(raw)];
  return {
    bgcolor: colors.bgcolor,
    color: colors.color,
    fontWeight: 700,
    textTransform: "none" as const,
    border: "none",
  };
}
